<template>
  <v-layout
    row
    wrap
    my-2
  >
    <v-flex lg4>
      <recent-users :items="users" />
    </v-flex>
    <v-flex lg8>
      <recent-posts :items="posts" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RecentUsers from '../components/RecentUsers'
import RecentPosts from '../components/RecentPosts'
export default {
  components: {
    RecentUsers,
    RecentPosts,
  },
  computed: {
    ...mapGetters({
      posts: 'blogPosts/posts',
      users: 'user/Users'
    })
  },
  created () {
    if (this.posts.length === 0) {
      this.getPosts({
        page: 1,
        rowsPerPage: 10
      })
    }
    if (this.users.length === 0) {
      this.getUsers({
        page: 1,
        rowsPerPage: 10
      })
    }
  },
  methods: {
    ...mapActions({
      getPosts: 'blogPosts/getPosts',
      getUsers: 'user/getUsers'
    })
  }
}
</script>
